export default __webpack_public_path__ + "static/sponsorship-874a4ae85a6c652a7cba2ead7a3349a5.png";